<div class="module_video">
    <div class="filter"></div>
    <video id="video-1-cryptmi" loop="loop" playsinline="" autoplay="" oncanplay="this.play()" onloadedmetadata="this.muted = true" poster="./assets/img/gennius/poster-imagine.webp">
        <source src="https://player.vimeo.com/progressive_redirect/playback/926432247/rendition/540p/file.mp4?loc=external&signature=74906d217738619344e97d8e8ac25b44445c2cc316c08ec6daa2b77b95d31ea1" type="video/mp4">
    </video>
</div>
<div class="gennius__right">
    <div class="module_text">
        <img src="./assets/img/gennius/logo-seed-group.webp" alt="gennius" class="img-seed">

        <img class="logo-gennius" src="./assets/img/logo-gennius.svg" alt="">
        <h2>MAY 9 <span>th</span></h2>
        <h2 class="city">DUBAI
            <span>Business Bay</span>
        </h2>
        <span>Join us as One</span>
        <p>Grab your spot for the revolution! Gear up for an event where disruption meets unity.</p>
    </div>
</div>

<div class="btn-intro">
    <span></span>Scroll
</div>

<section class="section-general" #scrollContainer>
<!-- <section class="section-general"> -->
    <section class="section section-parallax parallax-1 scroll-auto" id="item-c">
        <div class="bg-wrap">
            <div class="bg">
                <div class="container gennius">
                    <div class="gennius__bloque">
                        <div class="gennius__left">
                            <img src="./assets/img/gennius/logo-seed-group.webp" alt="gennius" class="img-seed">
                            <div class="gennius__center">
                                <img data-class-in="animate" class="img_one img_one1 img_one--fadeIn" src="./assets/img/gennius/one1.png">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <section class="section section-parallax scroll-auto" id="item-d">
        <div class="bg-wrap">
            <div class="bg">
                <div class="container gennius">
                    <div class="gennius__bloque">
                        <div class="gennius__left">
                            <img data-class-in="animate" src="./assets/img/gennius/logo-seed-group.webp" alt="gennius" class="img-seed">
                            <div class="gennius__center align_left">
                                <img data-class-in="animate" class="img_one img_one--fadeIn" src="./assets/img/gennius/one.png">
                                <h2 class="imagine-title">
                                    <span data-class-in="animate">currency</span><br>
                                    <span data-class-in="animate" class="subtext">rewards <small>|</small> fiat <small>|</small> crypto</span>
                                </h2>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </section>

    <section class="section section-parallax scroll-auto" id="item-e">
        <div class="bg-wrap">
            <div class="bg">
                <div class="container gennius">
                    <div class="gennius__bloque">
                        <div class="gennius__left">
                            <img src="./assets/img/gennius/logo-seed-group.webp" alt="gennius" class="img-seed">
                            <div class="gennius__center align_left">
                                <img class="img_one" src="./assets/img/gennius/one.png">
                                <h2 class="imagine-title imagine-title--wallet">
                                    <span data-class-in="animate">wallet</span><br>
                                    <span data-class-in="animate" class="subtext subtext--wallet">
                                        major e-wallets <small>|</small> web2 <small>|</small> web3
                                    </span>
                                    <span data-class-in="animate" class="subtext subtext--wallet-2">
                                        instant money movement
                                    </span>
                                </h2>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <section class="section section-parallax parallax-4 scroll-auto" id="item-f">
        <div class="bg-wrap">
            <div class="bg">
                <div class="container gennius">
                    <div class="gennius__bloque">
                        <div class="gennius__left">
                            <img src="./assets/img/gennius/logo-seed-group.webp" alt="gennius" class="img-seed">
                            <div class="gennius__center align_left">
                                <img class="img_one" src="./assets/img/gennius/one.png">
                                <h2 class="imagine-title imagine-title--marketplace">
                                    <span data-class-in="animate">global marketplace</span><br>
                                    <span data-class-in="animate" class="subtext subtext--marketplace">
                                        online <small>|</small> in store <small>|</small> metaverse
                                    </span>
                                </h2>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <section class="section gennius--layout gennius--network section_form scroll-auto">
        <div class="bg-form">
            <div class="container gennius">
                <div class="gennius__bloque">
                    <div class="gennius__left">
                        <img data-class-in="animate" class="img_one img_one1" src="./assets/img/gennius/one1.png">
                        <div class="text-form">
                            <p>Experience the<br>power of unity with</p>
                            <h1 class="text-gradient">ONE CURRENCY</h1>
                            <h1 class="text-gradient">ONE WALLET</h1>
                            <h1 class="text-gradient">ONE MARKETPLACE</h1>
                        </div>
                    </div>
                    <div class="gennius__right gennius__right--form">
                        <!-- url demo -->
                        <!-- <iframe class="mc-form" src="https://gennius.xyz/demo/assets/form/form.html" frameborder="0" scrolling="no"></iframe> -->
                        <!-- url PROD -->
                        <iframe class="mc-form" src="https://gennius.xyz/assets/form/form.html" frameborder="0" scrolling="no"></iframe>
                    </div>
                </div>
            </div>
        </div>
    </section>
</section>
